import { RoutePath } from '../../enums/RoutePath';

export const researchPaths = [
  RoutePath.ResearchRecent,
  RoutePath.ResearchDashboard,
  RoutePath.ResearchSpecialReports,
  RoutePath.ResearchRatingsSystem,
];
